'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var log2 = {};

exports.__exports = log2;
